const state = {
  course:{},
  currentQuestionScore: '', // 当前题目的评分
  currentQuestionMark: '' // 当前题目的备注
}

const mutations = {
  setCourseId (state, id) {
    state.courseId = id
  },
  setCourseList (state,courseList){
    state.courseList = courseList
  },
  setCourse (state, course) {
    state.course = course
  },
  setScore (state, score) {
    state.currentQuestionScore = score
  },
  setMark (state, mark) {
    state.currentQuestionMark = mark
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/homework.js